const zh_CN = {
	// Register
	1: '用户注册',
	2: '请输入用户名',
	3: '用户名必须以字母开头，只能包括字母、下划线、数字，长度必须在5至10之间',
	4: '请输入密码',
	5: '密码只能包括字母、数字，长度必须在6至15之间',
	6: '请再次输入密码',
	7: '请输入邮箱',
	8: '邮箱地址必须包含@字符',
	9: '邮箱@的左边除了开头字母其他的可以是字母, 下划线, 数字， 点号 . 小杠 -',
	10: '邮箱@的右边必须有 . 点号',
	11: '在 @ 和 . 之间必须以字母, 下划线, 数字开头, 且除了开头字母其他的可以是字母, 下划线, 数字， 点号 . 小杠 -',
	12: '男',
	13: '女',
	14: '请输入邀请码',
	15: '点击这里领取邀请码',
	16: '注册',
	17: '返回登录',
	18: '点击这里给我发消息',
	// Index
	19: '亲爱的疯坦，欢迎登录',
	20: '登录后才可以查看您的具体信息哦(包括战绩、战队、资产）',
	21: '官网个人信息显示略有延迟，请以游戏数据为准',
	22: '账号注册',
	23: '游戏下载',
	24: '充值',
	25: '新手指南',
	26: '高手进阶',
	27: '官方论坛',
	28: '配置需求',
	29: '战斗方法',
	30: '敬请期待',
	31: '道具介绍',
	32: '地图介绍',
	33: '坦克介绍',
	34: '新闻',
	35: '公告',
	36: '媒体评测',
	37: '玩家攻略',
	38: '论坛热帖',
	39: '更多媒体评测',
	40: '更多',
	// Apply
	41: '选择',
	42: '撤销',
	43: '通过',
	44: '战队名',
	45: '队长',
	46: '申请人',
	47: '等级',
	48: '成立时间',
	49: '已批准通过',
	50: '已拒绝通过',
	51: '已取消加入',
	// Create
	52: '创建战队(需要 ',
	53: ' 金币',
	54: '立即去充值',
	55: '退出',
	56: '战队名由3-12个字符组成',
	57: '颜色',
	58: '预览',
	59: '创建',
	60: '已经加入战队了，如果要创建战队，须先退出或解散原战队',
	61: '战队已成功创建',
	// Detail
	62: '解散战队',
	63: '退出战队',
	64: '操作',
	65: '删除',
	66: '昵称',
	67: '等级',
	68: '排名',
	69: '积分',
	70: '胜率',
	71: '最后游戏',
	72: '已删除队员',
	73: '确认解散战队?',
	74: '提示',
	75: '确定',
	76: '取消',
	77: '战队已成功解散',
	78: '已取消',
	79: '确认退出战队?',
	80: '战队已成功退出',
	// Guild Index
	81: '选择',
	82: '加入',
	83: '名称',
	84: '队长',
	85: '队员数',
	86: '成立时间',
	87: '战队积分',
	88: '申请已经提交，请等待队长审核!',
	// Recharge
	89: '充值',
	90: '充值方式',
	91: '充值金额',
	92: '立即可获赠 ',
	93: '金币',
	94: '积分赞助联系',
	95: '微信号:',
	96: 'wusuo72788',
	97: '感谢您的捐助与支持。',
	98: '为了继续维持爱上坦克运行,以下费用全部为无偿赞助行为，特此声明！',
	99: '感谢您对爱上坦克未来的支持！',
	100: '超级坦克团队 2023.8.22',
	101: '正在充值中，请耐心等待处理结果...',
	102: '关闭',
	103: 'Paypal充值',
	104: '支付宝扫码充值',
	105: '二维码充值',
	106: '充值已成功',
	// MotifyPassword
	107: '请输入旧密码',
	108: '请输入密码',
	109: '密码只能包括字母、数字，长度必须在6至15之间',
	110: '请再次输入密码',
	111: '修改',
	112: '请输入邮箱',
	113: '修改密码已完成',
	// Login
	114: '用户登录',
	115: '登录',
	// SideBar
	116: '首页',
	117: '战队',
	118: '战队列表',
	119: '战队详情',
	120: '创建战队',
	121: '加入申请',
	122: '账号',
	123: '修改密码',
	124: '金钱',
	125: '胜利',
	126: '失败',
	127: '账号状态',
	// 
	128: '点击即下载',
	129: '注意',
	130: '必须安装C++ Runtime',
	131: '请点击上方 PayPal 按钮',
	132: '商品选择',
	133: ' 积分',
	134: '为朋友充值',
	135: '朋友的昵称',
	136: '请输入昵称',
	137: '昵称长度必须在1至6之间.',
	138: '昵称',
	139: '修改昵称',
	140: '昵称类型',
	141: '普通(300 金币)',
	142: '特殊(1500 金币)',
	143: '修改昵称已完成',
	144: '检查',
	145: '注册已完成',
	146: '标题',
	147: '作者',
	148: '忘记密码',
	149: '下一步',
	150: '邮件已发送',
	151: '输入新密码',
	152: '搜索',
	153: '忘记用户名',
	154: '请输入新邮箱地址',
	155: '请再次输入新邮箱地址',
	156: '两次输入邮箱不一致',
	157: '修改邮箱地址',
	158: '修改邮箱已完成',
	159: '新邮箱',
	160: '邮箱',
	161: '修改战队名称',
	162: '修改战队颜色',
	163: '确定修改战队名称?',
	164: '确定修改战队颜色?',
	165: '修改战队名称已成功',
	166: '修改战队颜色已成功',
	167: '转让',
	168: '确定转让战队吗?',
	169: '转让战队已成功.',
	170: '订单金额',
	171: '最低购买数量1,500金币,每次以1,500递增',
	172: '最低购买数量1,000积分,每次以1,000递增',
	173: '修改用户性别',
	174: '修改用户性别已完成',
	175: '用户名',
	176: '经典版',
	177: 'HD',
	178: '超级坦克',
	179: '每一次浴火重生，都是新的开始，重拾那些年让我们热血沸腾的回忆...',
	180: '大小',
	181: '版本',
	182: '兼容性',
	183: '介绍',
	184: '确认下载游戏安装包？',
	185: '立即下载（安卓版）',
	186: '获取验证码',
	187: '请输入验证码',
	188: '下一步',
	189: '验证码长度六位',
	190: '登录已过期，请重新登录',
	191: '账号已在其他地方退出',
	// Loading states
	192: '处理中...',
	193: '登录中...',
	194: '验证中...',
	195: '注册中...',
	196: '创建中...',
	// Validation messages
	197: '请输入邮箱',
	198: '请填写用户名和邮箱',
	199: '请填写邮箱和验证码',
	200: '请输入昵称',
	201: '请填写完整信息',
	202: '两次密码不一致',
	203: '请输入战队名称',
	// Empty states
	205: '暂无申请',
	206: '暂无成员',
	207: '已激活',
	// Discord page
	208: '加入我们的 Discord 社区，获取最新游戏资讯、活动公告，与全球玩家交流！',
	209: '在线成员',
	210: '游戏公告频道',
	211: '玩家交流频道',
	212: '主要频道',
	213: '🎮 加入 Discord 社区',
	// Download page
	214: '官方正版 | 安全无捆绑 | 直装APK',
	215: 'App Store 搜索 "SuperTank" 亦可下载',
	216: 'Android 下载',
	217: 'iOS 下载',
	218: '请使用手机扫描二维码下载',
	// PC Index footer
	219: '陆讯电脑系统科技有限公司',
	// Login page
	220: '请输入账号',
	221: '请输入密码',
	222: '← 返回首页',
	223: '点击此处下载 APK',
	224: '预览',
	225: '余额不足',
	226: '不足，需要',
	227: '修改性别需要',
	// Download page game description
	228: 'SuperTank-驾驭钢铁猛兽，征服全世界！\n\n精致的坦克，自由组装\n从经典战车到高科技坦克，多种独特的坦克装甲设计任你选择！火力、装甲、机动性自由组合，打造你的超级坦克，在战场上所向披靡！\n\n硬核操作，秀出技巧\n精准瞄准与灵活的走位，战术规避…每场比赛都是技术与策略的终极考验！单人或团队战斗，用实力碾压对手，登顶世界排名！\n\n深度升级，策略为王\n从火炮到引擎，每个部件都可以强化！搭配不同的技能和装备，开发独特战术，打造无敌坦克军团，征服所有挑战！\n\n全球实时对决\n来自世界各地的玩家，展现你的超级坦克！多种模式让你畅快战斗！\n\n立即下载，开启钢铁征程！\n在超级坦克的世界里，每一颗炮弹都在书写你的传说——成为主宰者还是炮灰？由你决定！',
	// ErrorCode
	1000: '成功',
	1001: '失败',
	1002: '用户名不符合规则',
	1003: '密码不符合规则',
	1004: '邮箱不符合规则',
	1005: '未加入任何战队',
	1006: '身份证不符合规则',
	1007: '用户名已存在',
	1008: '用户名不正确',
	1009: '密码不正确',
	1010: '账号已锁定',
	1011: '性别不符合规则',
	1012: '已经加入战队',
	1013: '已经申请过战队',
	1014: '铜勋章以上才可以建立战队',
	1015: '战队名称重复',
	1016: '战队不存在',
	1017: '未加入战队',
	1018: '队长才能审核',
	1019: '不是该战队的成员，不能查看列表',
	1020: '战队名称不正确',
	1021: '没有战队加入申请表',
	1022: '订单不正确',
	1023: '金币数量不正确，创建战队需要3000金币',
	1024: '邀请码不正确',
	1025: '邀请码已使用',
	1026: '队长不能够删除',
	1027: '未知的错误',
	1028: '无访问权限',
	1029: '昵称不正确',
	1030: '昵称已存在',
	1031: '昵称不符合规则',
	1032: '金币数量不正确',
	1033: '开始时间不正确',
	1034: '结束时间不正确',
	1035: '金币不正确',
	1036: '二维码类型不正确',
	1037: '二维码不正确',
	1038: '验证码不正确',
	1039: '邮箱不正确',
	1040: '超过每日重置次数上限',
	1041: '分数不正确',
	1042: 'Receipt不正确',
	1043: 'GiftType不正确',
	1044: '商品数量不正确',
	1045: 'TerminalType不正确',
	1046: '支付方式不正确',
	1047: 'Tier不正确',
	1048: 'SteamId不正确',
	1049: 'PayPal创建订单失败',
	1050: 'Steam创建订单失败',
	1051: '授权验证失败',
	1052: '授权解码失败',
	1053: '邮箱验证码已发送',
	1054: '获取邮箱验证码太频繁',
	1055: '邮箱验证码不正确',
	1056: '该邮箱地址已被列入黑名单',
	1057: 'Discord 未配置',
	1058: 'Discord API 请求失败',
	1059: '获取 Discord 新闻失败',
	1060: 'Discord 公告',
	1061: '支付宝扫码充值',
	1062: '扫码充值中，请耐心等待处理结果...',
	1063: '关闭',
	1064: '返回首页',
	1065: '用户名,非论坛账号',
	1066: '密码',
	1067: '超级坦克',
	1068: '点击这里给我发消息',
}

export default {
	...zh_CN,

	1069: '加载中...',
	1070: '没有更多了',
	1071: '暂无新闻',

	1072: '排行榜',
	1073: '暂无排名数据',
}